import * as queryString from 'query-string';
import { useState, useEffect, useMemo } from 'react';
import { CookieTokenStore, LocalStorageTokenStore, HttpConfigService, LocalConfigStore, configure, TokenServiceActions, ProviderTypes, SansConnectService } from '@sans-tesseract/sdk';
import Cookies from 'js-cookie';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var service = {};
var getSansSDK = function () {
  if (!service.Sans) throw 'SansSDK not defined setSansSDK must be called';
  return service.Sans;
};
var setSansSDK = function (core) {
  return service.Sans = core;
};
var getWindow = function () {
  if (!service.window) throw 'Window not defined setWindow must be called';
  return service.window;
};
var setWindow = function (window) {
  return service.window = window;
};
var STORAGE_KEY_PREFIX = "sans-auth";
var configureReact = function (SansSDK, options) {
  if (options === null || options === void 0 ? void 0 : options.window) setWindow(options === null || options === void 0 ? void 0 : options.window);
  setSansSDK(SansSDK);
  var keyPrefix = STORAGE_KEY_PREFIX;
  var tokenStore = new CookieTokenStore(options.cookies || Cookies, options.cookieOptions || {
    refresh: {}
  }, new LocalStorageTokenStore(keyPrefix));
  var window = getWindow();
  window.addEventListener("storage", function (event) {
    var key = event.key,
        oldValue = event.oldValue,
        newValue = event.newValue;

    if (key.startsWith(keyPrefix) && oldValue !== newValue) {
      getSansSDK().api.tokens.notifyTokens();
    }
  });
  var configService = new HttpConfigService((options === null || options === void 0 ? void 0 : options.initialEnvironment) || {
    development: {
      uri: "https://dev-www.sans.org/remote-config/web.json"
    }
  });
  configService.configStore = new LocalConfigStore();
  configure(SansSDK, {
    configService: configService,
    tokenStore: tokenStore
  });
};

function resetArgs(location, title, queryArgs, hashArgs) {
  if (queryArgs === void 0) {
    queryArgs = {};
  }

  if (hashArgs === void 0) {
    hashArgs = {};
  }

  var query = queryString.stringify(queryArgs);
  var hash = queryString.stringify(hashArgs); // TODO only remove specific args and reconstruct url

  window.history.pushState('', title, "".concat(location.pathname).concat(query ? "?".concat(query) : '').concat(hash ? "#".concat(hash) : ''));
}
var useIdToken = function () {
  var SansSDK = getSansSDK();

  var _a = useState({
    loading: true,
    token: SansSDK.api.tokens.id
  }),
      token = _a[0],
      setToken = _a[1];

  useEffect(function () {
    // refreshes the tokens, we can expect the system event to deal with updating the state below
    if (SansSDK.api.tokens.refresh) {
      (function () {
        return __awaiter(void 0, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , SansSDK.api.tokens.freshTokens()];

              case 1:
                _a.sent();

                setToken({
                  loading: false,
                  token: SansSDK.api.tokens.id
                });
                return [2
                /*return*/
                ];
            }
          });
        });
      })();
    } else {
      setToken({
        loading: false,
        token: SansSDK.api.tokens.id
      });
    }

    return SansSDK.api.systemEvents.subscribe(TokenServiceActions.UPDATE_TOKENS, function (_a) {
      var id = _a.payload.id;
      return setToken({
        loading: false,
        token: id
      });
    });
  }, [SansSDK]);
  return token;
};
var useUserInfo = function () {
  var token = useIdToken().token;
  var SansSDK = getSansSDK();
  var tokenInfo = useMemo(function () {
    return SansSDK.api.tokens.decodedIdToken();
  }, [token]);
  return tokenInfo;
};
var processLocation = function (_a) {
  var _b = _a.window,
      window = _b === void 0 ? getWindow() : _b;
  return __awaiter(void 0, void 0, void 0, function () {
    var location, origin, hash, search, queryArgs, hashArgs, SansSDK, redirectPath, tokens, tokens, _i, _c, key, logoutDestination, window_1;

    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          location = window.location;
          origin = location.origin, hash = location.hash, search = location.search;
          queryArgs = queryString.parse(search);
          hashArgs = queryString.parse(hash);
          SansSDK = getSansSDK();
          if (!queryArgs.code) return [3
          /*break*/
          , 3];
          return [4
          /*yield*/
          , SansSDK.api.cognito.config()];

        case 1:
          redirectPath = _d.sent().redirectPath;
          return [4
          /*yield*/
          , SansSDK.api.cognito.tokensFromCode(queryArgs.code, "".concat(origin).concat(redirectPath))];

        case 2:
          tokens = _d.sent();
          SansSDK.api.tokens.updateTokens(tokens);
          delete queryArgs.code;
          resetArgs(location, undefined, queryArgs, hashArgs);
          return [3
          /*break*/
          , 8];

        case 3:
          if (!queryArgs.assumeToken) return [3
          /*break*/
          , 4];
          SansSDK.api.tokens.updateTokens({
            id: queryArgs.assumeToken
          });
          delete queryArgs.assumeToken;
          resetArgs(location, undefined, queryArgs, hashArgs);
          return [3
          /*break*/
          , 8];

        case 4:
          if (!hashArgs.id_token) return [3
          /*break*/
          , 5];
          tokens = {};

          for (_i = 0, _c = ["id", "access", "refresh"]; _i < _c.length; _i++) {
            key = _c[_i];

            if (hashArgs["".concat(key, "_token")]) {
              tokens[key] = hashArgs["".concat(key, "_token")];
            }
          }

          SansSDK.api.tokens.updateTokens(tokens);
          resetArgs(location, undefined, queryArgs, {});
          return [3
          /*break*/
          , 8];

        case 5:
          if (!queryArgs.logout) return [3
          /*break*/
          , 8];
          return [4
          /*yield*/
          , SansSDK.api.tokens.clear()];

        case 6:
          _d.sent();

          return [4
          /*yield*/
          , SansSDK.api.cognito.config()];

        case 7:
          logoutDestination = _d.sent().logoutDestination;

          if (logoutDestination) {
            window_1 = getWindow();
            window_1.location.href = logoutDestination;
          }

          _d.label = 8;

        case 8:
          return [2
          /*return*/
          , {
            queryArgs: queryArgs,
            hashArgs: hashArgs
          }];
      }
    });
  });
};
var login = function (options) {
  if (options === void 0) {
    options = {};
  }

  getSSOLoginUrl(options).then(function (url) {
    var window = getWindow();
    window.location.href = url;
  });
};
var logout = function () {
  // if our token tells us that we have a specific auth source (like in the case
  // of impersonation) then clear tokens and send user to auth source
  var SansSDK = getSansSDK();
  var token = SansSDK.api.tokens.decodedIdToken();

  if (token && (token === null || token === void 0 ? void 0 : token.authSource)) {
    SansSDK.api.tokens.clear().then(function () {
      window.location.href = token.authSource;
    });
  } else {
    getSSOLogoutUrl().then(function (url) {
      var window = getWindow();
      window.location.href = url;
    });
  }
};
var getSSOLoginUrl = function (options) {
  if (options === void 0) {
    options = {};
  }

  return __awaiter(void 0, void 0, void 0, function () {
    var SansSDK;
    return __generator(this, function (_a) {
      SansSDK = getSansSDK();
      return [2
      /*return*/
      , SansSDK.api.cognito.oauthProviderRedirectUrl(origin, ProviderTypes.SANS_IDP, options)];
    });
  });
};
var getSSOLogoutUrl = function () {
  return __awaiter(void 0, void 0, void 0, function () {
    var SansSDK, window, redirectPath;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          SansSDK = getSansSDK();
          window = getWindow();
          return [4
          /*yield*/
          , SansSDK.api.cognito.config()];

        case 1:
          redirectPath = _a.sent().redirectPath;
          return [2
          /*return*/
          , SansSDK.api.cognito.oauthLogoutUrl("".concat(window.location.origin).concat(redirectPath, "?logout=true"))];
      }
    });
  });
};

var useSansConnect = function (onMessage) {
  var Sans = getSansSDK();

  var subscribe = function (channelId) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , Sans.api.connect.subscribe(channelId)];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  var connect = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , Sans.api.connect.connect()];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  var send = function (channelId, message) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            console.log(channelId, message);
            return [4
            /*yield*/
            , Sans.api.connect.send(channelId, message)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  var disconnect = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , Sans.api.connect.disconnect()];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  var _a = useState(false),
      connected = _a[0],
      setConnected = _a[1];

  useEffect(function () {
    return Sans.api.systemEvents.subscribe(SansConnectService.Actions.READY, function () {
      setConnected(true);
    });
  }, []);
  useEffect(function () {
    return Sans.api.systemEvents.subscribe(SansConnectService.Actions.CLOSE, function () {
      setConnected(false);
    });
  }, []);
  useEffect(function () {
    if (onMessage) {
      return Sans.api.systemEvents.subscribe(SansConnectService.Actions.MESSAGE, function (message) {
        onMessage(message);
      });
    }
  }, [onMessage]);
  return {
    connect: connect,
    disconnect: disconnect,
    subscribe: subscribe,
    send: send,
    connected: connected
  };
};

export { configureReact, getSSOLoginUrl, getSSOLogoutUrl, getSansSDK, getWindow, login, logout, processLocation, setSansSDK, setWindow, useIdToken, useSansConnect, useUserInfo };
